import { render, staticRenderFns } from "./ContextChip.vue?vue&type=template&id=407b2a8e&"
import script from "./ContextChip.vue?vue&type=script&lang=ts&"
export * from "./ContextChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports